module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_chapel@3x-a238e72145e5ed872e29abd612c00886.webp";